import { render, staticRenderFns } from "./SocialDebtorsUploadForm.vue?vue&type=template&id=5d1c1b18&scoped=true&"
import script from "./SocialDebtorsUploadForm.vue?vue&type=script&lang=js&"
export * from "./SocialDebtorsUploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1c1b18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VFileInput,VForm})
